/* @sravni/react-design-system version 0.2.71 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_e185b7e9 from '../styles/Skeleton.module.less.js';

/**
 * @description Skeleton Avatar component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Avatar />
 * ```
 */
var Avatar = function (props) {
    var className = props.className, _a = props.inverted, inverted = _a === void 0 ? false : _a, restProps = __rest(props, ["className", "inverted"]);
    var cx = useStyles(modules_e185b7e9);
    var classNames = cx(className, 'avatar', { inverted: inverted });
    return React.createElement("div", __assign({ className: classNames }, restProps));
};
Avatar.displayName = 'Avatar';

export { Avatar };
//# sourceMappingURL=Avatar.js.map
